import TrackElements from '@capsule/track-elements'
import Carousel from 'shared/carousel/carousel'

export default class ArticleRelatedRecipes {
	private relatedRecipesWrapper: HTMLElement | null
	private relatedRecipes: HTMLElement | null
	private relatedRecipesItems: NodeListOf<HTMLElement> | null
	private isDesktop: boolean
	private hasOverflow: boolean

	constructor() {
		this.relatedRecipesWrapper = document.querySelector('.articleRelatedRecipes')
		this.relatedRecipes =
			this.relatedRecipesWrapper?.querySelector('.articleRelatedRecipes-list') || null
		this.relatedRecipesItems = this.relatedRecipes?.querySelectorAll('.contentCard') || null
		this.isDesktop = window.matchMedia('(min-width: 1000px)').matches
		this.hasOverflow =
			(this.relatedRecipes?.scrollWidth || 0) > (this.relatedRecipes?.clientWidth || 0)
		this.initCarousel = this.initCarousel.bind(this)
	}

	init() {
		if (!this.relatedRecipesWrapper) return

		if (this.isDesktop && this.hasOverflow) {
			this.initCarousel()
		}

		this.initTracking()
	}

	initCarousel() {
		if (!this.relatedRecipesWrapper) return

		const carousel = new Carousel({
			element: this.relatedRecipesWrapper,
			itemsToScrollBy: 2
		})

		carousel.init()
	}

	initTracking() {
		const trackElements = new TrackElements(this.trackingEntries)
		trackElements.init()
	}

	get trackingEntries() {
		if (!this.relatedRecipesItems) return []

		const displayEntry = {
			element: this.relatedRecipesWrapper,
			display: {
				event: 'navigation_display',
				navigation_type: 'related-recipes',
				navigation_label: 'carrousel-mijotez-vos-prochaines-recettes'
			}
		}

		const clickEntries = [...this.relatedRecipesItems].map((element, index) => ({
			element,
			click: {
				event: 'navigation_click',
				navigation_type: 'related-recipes',
				navigation_label: 'carrousel-mijotez-vos-prochaines-recettes',
				navigation_name: `recipe-${index + 1}`
			}
		}))

		return [displayEntry, ...clickEntries]
	}
}
